/* 
* WP Theme custom scripts 
*/
import './partials/partials';